export default "__VITE_ASSET__YV3sNEE___"